import React from 'react'
import { withTranslation } from 'react-i18next'

import logo from '../images/icons/logo_blue.svg'

const Loader = ({ text = 'Loading...', view = '1', t }) => {
    let label = t('_components._loader.please_wait')
    if (text) {
        label = text
    }

    return (
        <div data-view={`${view}`} className="main-loader">
            <img src={logo} alt="" />
            <p>{label}</p>
            <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default withTranslation('translations')(Loader)
